import { Link } from "react-router-dom";
import CompanyFetch from "./CompanyFetch";
import HeadingSection from "./HeadingSection";
import styled from "styled-components";
import { Helmet } from "react-helmet";
import { useEffect, useState } from "react";
import "./mega-menu.css";
import BodyLink from "./StyledComponents/BodyLink";
import InputField from "./StyledComponents/InputField";
import Button from "./StyledComponents/Button";
import Div from "./StyledComponents/Div";
import BranchLink from "./StyledComponents/BranchLink";
import BranchDiv from "./StyledComponents/BranchDiv";


let yr=2024;

export default function InsightPlacement2022() {
  const [Company_Query, setCompany_Query] = useState("");
  const [Branch, setBranch] = useState("all");
  const [Year, setYear] = useState(yr);
  const years = ["2021", "2022", "2023","2024","2025", "2026"];

  useEffect(()=>{
    yr=Year;
  },[Year])

  const set_Branch = (e) => {
    setBranch(e.target.name);
  };

  const set_Company_Query = (e) => {
    setCompany_Query(e.target.value);
  };

  const branches_BTech = [
    ["ce", "che", "cse", "ece"],
    ["ee", "ep", "ese", "fme"],
    ["me", "mech", "mme", "pe"],
  ];
  const branches_IntMTech = [["agl", "agp", "mnc"]];

  const Dropdown_1 = branches_BTech.map((element) => (
    <BranchDiv key={element}>
      {element.map((branch) => (
        <BranchLink key={branch} onClick={(e) => set_Branch(e)} name={branch}>
          {branch.toUpperCase()}
        </BranchLink>
      ))}
    </BranchDiv>
  ));
  
  const Dropdown_2 = branches_IntMTech.map((element) => (
    <BranchDiv key={element}>
      {element.map((branch) => (
        <BranchLink key={branch} onClick={(e) => set_Branch(e)} name={branch}>
          {branch.toUpperCase()}
        </BranchLink>
      ))}
    </BranchDiv>
  ));


  const Dropdown_3 = years.map((element) => (
    <BranchDiv key={element}>
      <BranchLink onClick={()=> setYear(element)} >
        {element}
        {console.log(element)}
      </BranchLink>
    </BranchDiv>
  ));

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Placement Insight</title>
        <link
          rel="icon"
          type="image/png"
          href="https://github.com/MejarKumar/All-Company-Logo/blob/main/favicon-32x32.png?raw=true"
        />
        <meta name="theme-color" content="#064420" />
      </Helmet>

      <HeadingSection />
      
      
      <InputField
        autoFocus
        placeholder="Search Here"
        value={Company_Query}
        onChange={set_Company_Query}
      />
      <Button>Search</Button>
      
      <Div>
        <div className="dropdown">
          <button className="dropbtn">{Branch.toUpperCase()}</button>
          <div className="dropdown-content">
            <h1 style={{fontSize: 30,marginLeft: 35, marginTop: 15}}>Branches</h1>
            <BranchDiv>
              <BranchLink onClick={(e) => set_Branch(e)} name="all">
                All
              </BranchLink>
            </BranchDiv>
            <div className="sub-heading">B.Tech</div>
            {Dropdown_1}
            <div className="sub-heading">Int. M.Tech</div>
            {Dropdown_2}
          </div>
        </div>
        <div className="dropdown">
          <button className="dropbtn">Year</button>
          <div className="dropdown-content">
            <h1 style={{fontSize: 30,marginLeft: 35, marginTop: 15}}>Select Year: </h1>
            {Dropdown_3}
          </div>
        </div>

      </Div>
      <CompanyFetch
        url="placement"
        query={Company_Query}
        type="placement"
        year={Year}
        branch={Branch}
      />
    </>
  );
}
